import React, { useState } from 'react';

import { refreshGladly } from '../../api';
import { RefreshIcon } from '../../assets/RefreshIcon';
import { GLADLY_URL } from '../../constants';
import { DeletePII } from '../DeleteCustomerPII';

import { Lead } from '@/pages/types';

export const AccountAndContactInfo = ({ lead }: { lead: Lead }) => {
  const [isRefreshGladlyLoading, setIsRefreshGladlyLoading] = useState<boolean>(false);

  const showDeletePiiOption = !lead.email.includes('DELETED');
  const accountId = lead.account_id;

  return (
    <div className="flex-col">
      <h2 className="mb-1 flex items-center">
        <b className="inline-block">Lead Details</b>
      </h2>
      <div className="bg-white border rounded-lg p-4 shadow-md h-[260px] overflow-y-scroll">
        <div className="mb-2">
          <strong>Customer ID:</strong> {accountId || '--'}
        </div>
        <div className="mb-2 flex items-center">
          <strong>Email address:</strong>{' '}
          <div className="flex items-center ml-1">
            <span>{lead.email}</span>
            {showDeletePiiOption && <DeletePII email={lead.email} is_lead id={lead.id} />}
          </div>
        </div>
        <div className="mb-2">
          <strong>Account status:</strong> {lead.account_status || '--'}
        </div>
        <div className="mb-2 gap-2 flex flex-row">
          <div>
            <strong>Gladly ID:</strong>{' '}
            {lead.account_gladly_customer_id ? (
              <a
                href={`${GLADLY_URL}customer/${lead.account_gladly_customer_id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
              >
                {lead.account_gladly_customer_id}
              </a>
            ) : (
              '--'
            )}
          </div>
          {accountId && (
            <button
              type="button"
              aria-label="Refresh Gladly profile"
              disabled={isRefreshGladlyLoading}
              onClick={async () => {
                setIsRefreshGladlyLoading(true);
                await refreshGladly(accountId);
                setIsRefreshGladlyLoading(false);
                setTimeout(() => {
                  window.location.reload();
                }, 2000);
              }}
              className="hover:cursor-pointer"
            >
              <RefreshIcon className="h-4 w-4" />
            </button>
          )}
        </div>
        <div className="mb-2">
          <strong>Pricing Model:</strong> {lead.pricing_model?.name}
        </div>
        <div className="mb-2">
          <strong>Dogs:</strong>
          {lead.funnel_session_pet_answers?.length ? (
            <ul className="ml-4 list-disc">
              {lead.funnel_session_pet_answers.map((pet) => (
                <li key={pet.id}>
                  {pet.name || `Dog ${pet.pet_index + 1}`}:{' '}
                  {pet.plan_size
                    ? `${Math.round(Number(pet.plan_size)).toLocaleString()} kcal/day`
                    : '--'}
                </li>
              ))}
            </ul>
          ) : (
            ' --'
          )}
        </div>
      </div>
    </div>
  );
};
